﻿import { FC, HTMLAttributes } from 'react';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export const Container: FC<ContainerProps> = ({ children, size = 'xl', className = '', style, ...props }) => {
  return (
    <div className={`cs-container cs-container-${size} ${className}`.trim()} style={style} {...props}>
      {children}
    </div>
  );
};

